import { Link } from "react-router-dom";

const trustItems = [
  { icon: "ri-shield-check-line", label: "100% Verified Suppliers", desc: "Every factory & farm is background-checked and certified" },
  { icon: "ri-leaf-line", label: "Farm-to-Door Fresh", desc: "Direct from American farms — honey, dairy, grains & more" },
  { icon: "ri-building-2-line", label: "USA Factory Made", desc: "Manufactured in American facilities with strict quality standards" },
  { icon: "ri-award-line", label: "USDA & FDA Certified", desc: "All food and farm products meet federal safety requirements" },
  { icon: "ri-truck-line", label: "Ships USA & Canada", desc: "Fast 2-5 day delivery from local warehouses coast to coast" },
  { icon: "ri-hand-heart-line", label: "Support Local Farmers", desc: "Every purchase supports American family farms and factories" },
];

const USAMadeBanner = () => (
  <section className="bg-white border-y border-gray-100 py-10">
    <div className="max-w-[1400px] mx-auto px-6">
      {/* Top headline */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
        <div className="flex items-center gap-5">
          <span className="text-6xl md:text-7xl">🇺🇸</span>
          <div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight">
              Verified Factory and Farm
            </h2>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#C41E3A] leading-tight tracking-tight">
              Suppliers Made in USA
            </h2>
            <p className="text-gray-500 text-base mt-2">
              Background-checked American factory &amp; farm suppliers — shipped direct to your door
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/products"
            className="flex items-center gap-2 bg-[#C41E3A] text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-[#a01830] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-store-2-line"></i> Shop USA Made
          </Link>
          <Link
            to="/supplier-register"
            className="flex items-center gap-2 border-2 border-[#C41E3A] text-[#C41E3A] px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-[#C41E3A] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-building-2-line"></i> Become a Supplier
          </Link>
        </div>
      </div>

      {/* Trust badges grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {trustItems.map((item) => (
          <div
            key={item.label}
            className="flex flex-col items-center text-center p-4 rounded-lg bg-[#fdf8f4] border border-[#f0e8e0] hover:border-[#C41E3A]/30 transition-colors"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-[#C41E3A]/10 rounded-full mb-3">
              <i className={`${item.icon} text-[#C41E3A] text-lg`}></i>
            </div>
            <div className="font-bold text-gray-900 text-xs mb-1 leading-tight">{item.label}</div>
            <div className="text-gray-500 text-[10px] leading-relaxed">{item.desc}</div>
          </div>
        ))}
      </div>

      {/* Stats strip */}
      <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 bg-gradient-to-r from-[#C41E3A] to-[#8B0000] rounded-lg p-5">
        {[
          { value: "50+", label: "Verified USA Suppliers" },
          { value: "500+", label: "Farm & Factory Products" },
          { value: "12", label: "US States Represented" },
          { value: "100%", label: "American Made & Grown" },
        ].map((stat) => (
          <div key={stat.label} className="text-center">
            <div className="text-2xl font-extrabold text-[#D4AF37]">{stat.value}</div>
            <div className="text-white/80 text-xs mt-0.5">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default USAMadeBanner;
